import * as styles from './flex-mark.css';

/** Pluma Icons has no Flex mark, and its icons are single-colour. */
export function FlexMark() {
  return (
    <svg className={styles.mark} viewBox="0 -5 90 90" aria-hidden="true" focusable="false" data-testid="flex-mark">
      <path
        className={styles.accent}
        d="M47.5592 0C53.3148 2.81778 58.2007 5.81993 62.5306 8.49682C72.111 14.4211 76.9194 17.011 90.0014 17.011V6.01126C79.9358 6.01126 76.7495 5.18332 68.3571 0H47.5592Z"
      />
      <path
        className={styles.accent}
        d="M27.4676 71.5107C17.8921 65.5899 13.0854 63.0104 0.00170898 63.0104V74.0101C10.0706 74.0101 13.2537 74.8294 21.6461 80.011H42.4423C36.6851 77.1932 31.7975 74.1893 27.4676 71.5107Z"
      />
      <path
        className={styles.body}
        d="M89.9998 27.0107C74.2264 27.0107 67.5831 22.9023 57.5225 16.6823C44.9141 8.8847 29.2249 0 0 0L0.0016501 11.0102C26.5353 11.0102 40.335 18.1521 52.5128 25.6835C63.1427 32.2566 71.5351 38.0105 89.9998 38.0105V27.0107ZM89.9998 69.0112C63.4661 69.0112 49.6664 61.0397 37.487 53.5082C26.8587 46.9352 18.4679 42.011 0 42.011L0.0016501 53.0108C15.7766 53.0108 22.4199 56.2895 32.4789 62.5095C45.0857 70.3071 60.7781 80.011 90.0014 80.011L89.9998 69.0112Z"
      />
      <path
        className={styles.body}
        d="M90.0014 59.1386C66.1558 59.1386 54.1282 51.6993 42.4967 44.5053C31.5235 37.72 21.1559 32.0114 0 32.0114L0.0016501 21.0116C23.8472 21.0116 35.8748 28.3117 47.5064 35.5058C58.4795 42.291 68.8471 48.1284 90.0014 48.1284V59.1386Z"
      />
    </svg>
  );
}
